/**
 * Dialog for capturing a handwritten signature.
 * Props: open flag, onClose and onSave handlers.
 */
import { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button, Box, Paper, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DigitalSignature = ({ open, onClose, onSave }:any) => {
  const signaturePadRef = useRef<SignatureCanvas>(null);


  const clearSignature = () => {
    try {
      signaturePadRef.current?.clear();
    } catch (e) {
      console.log(e);
    }
  };

  const saveSignature = () => {
    if (!signaturePadRef.current) {
      console.error("signaturePadRef.current es null");
      return;
    }
  
    if (typeof signaturePadRef.current.getTrimmedCanvas !== "function") {
      console.error("getTrimmedCanvas() no está disponible.");
      return;
    }
    const trimmedCanvas = signaturePadRef.current.getTrimmedCanvas();
    const signatureImage = trimmedCanvas.toDataURL();
    onSave(signatureImage);
    onClose();
  };
  
  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogTitle>
        Firma Digital
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
          <Paper 
            elevation={3} 
            sx={{ 
              border: '2px solid #000', 
              width: '80%', 
              height: '80%', 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center' 
            }}
          >
            <SignatureCanvas
              ref={signaturePadRef}
              penColor="black"
              canvasProps={{
                style: { width: '100%', height: '100%' }
              }}
            />
          </Paper>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={clearSignature} color="secondary" variant="outlined">
          Borrar Firma
        </Button>
        <Button onClick={saveSignature} color="primary" variant="contained">
          Guardar Firma
        </Button>
        <Button onClick={onClose} color="inherit" variant="outlined">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DigitalSignature;
